function toBase64(file: Blob) {
  return new Promise<FileReader['result']>((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });
}

function download(fileName: any, url: string): void {
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.click();
}

export { download, toBase64 };
